import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { config } from '../lib/boot-config';

const firebaseSetup = async () => {
  const fb = await config.getFirebase();
  // console.log(`In firebaseSetup, client config: ${fb.clientConfig}`)
  if (!fb.vapidKey) {
    return {
      enabled: false
    }
  }
  const app = initializeApp(fb.clientConfig);
  // console.log(`In firebaseSetup, app: ${app.name}`)
  const setup = {
    enabled: true,
    clientConfig: fb.clientConfig,
    vapidKey: fb.vapidKey,
    app: app,
    endpoint: fb.endpoint,
  };
  // console.log(`In firebaseSetup, setup: ${JSON.stringify(setup)}`)
  return setup;
};

export const requestPermission = async () => {
  const setup = await firebaseSetup();
  // console.log(`On "requestPermission" setup: ${JSON.stringify(setup)}`)
  // console.log(`On "requestPermission" Firebase setup: ${setup.clientConfig}`)
  if (!setup || !setup.enabled) {
    console.error('Firebase disabled')
    return;
  }
  try {
    const messaging = await getMessaging(setup.app);

    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    console.log(`In requestPermission, browser notification perms: "${permission}"`);
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: setup.vapidKey
      });

      //We can send token to server
      // console.log('Token generated : ', token);

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      const raw = JSON.stringify({
        token: token,
        deviceId: 'device-id',
      });
      const requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw,
      };
      fetch('/rqx/session/device-token', requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(`Response from device-token endpoint: ${result}`))
        .catch((error) => console.error('Error registering device token', error));

    } else {
      console.error('Notification not granted: ', permission);
    }
  } catch (error) {
    console.log('==============================');
    console.log('>>>   ', error);
    console.log('==============================');
  }
}
